import { createSelector } from '@reduxjs/toolkit';
import { rootSelector } from '../../root/root.selectors';

export const userProfileSelector = createSelector(rootSelector, state => state.userProfile);
